import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
// import { Redirect } from "react-router";
import Page from "../../Components/Page";
import { makeStyles } from "@material-ui/core/styles";
import { IconButton } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import axios from "axios";
import { useHistory } from "react-router-dom";
import noImg from "../../Assets/images/no-image.svg";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import { withTranslation, useTranslation, Trans } from "react-i18next";
import StateContext from "../../StateContext";
import DispatchContext from "../../DispatchContext";
// import { freezOn, freezOff, handleError } from "../../../redux-store/action";
// global funtion for store
import { get_lang } from "../../Functions/getLang";

// redux
import LinearProgress from "@mui/material/LinearProgress";
import Avatar from "@mui/material/Avatar";
// import { parseNumber, roundFixed } from "../../../global-functions/roundFixed";
import OrderProductv2 from "../../Components/OrderProductv2/OrderProductv2";
// import { getLiveData } from "../../../global-functions/pusher";
import vendorsConfig from "../../vendorsConfig";

const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1),
  },
}));

function OrderStatus({ openOrders }) {
  const { t } = useTranslation();

  const classes = useStyles();
  const [dineinOrders, setDineInOrders] = useState([]);
  const appState = useContext(StateContext);
  const appDispatch = useContext(DispatchContext);
  // console.log("dineinOrders", dineinOrders)
  const [groupBillDetails, setGroupBillDetails] = useState({});
  var initial_State = true;
  const [isLoading, setIsLoading] = useState(true);
  const [myOrdersAmount, setMyOrdersAmount] = useState(0);
  const [friendsOrdersAmount, setFriendsOrdersAmount] = useState(0);
  const [invoiceId, setInvoiceId] = useState(null);
  // const {
  //   totalAmount = 0,
  //   subTotalAmount = 0,
  //   discount = 0,
  //   totalCharges = 0,
  //   totalTax = 0,
  //   adjustedAmount = 0,
  //   tip = 0,
  //   charges = [],
  // } = appState.invoiceTaxesChargesExtras;
  const [url, setUrl] = useState(process.env.REACT_APP_SHOP_URL);

  // const [formData, setFormData] = useState(
  //   JSON.parse(localStorage.getItem(`${appState.storeInfo.slug}_form`)) !== null
  //     ? JSON.parse(localStorage.getItem(`${appState.storeInfo.slug}_form`))
  //     : {}
  // );
  const [formStatus, setFormStatus] = useState(false);

  let history = useHistory();
  const [progress, setProgress] = useState(20);




  const arLanguageHandle = (e) => {
    // console.log("ar change");
    appDispatch({
      type: "LangChange",
      langValue: "ar",
    });
  };
  const enLanguageHandle = (e) => {
    // console.log("en change");

    appDispatch({
      type: "LangChange",
      langValue: "en",
    });
  };
  useEffect(() => {
   setIsLoading(false)
  }, [])
  

  if (isLoading)
    return (
      <>
        <div className="row mx-1">
          <div className="col-1 col-md-1 px-2">
            <Skeleton height={50} />
          </div>
          <div className="col-3 col-md-2 px-2">
            <Skeleton height={50} />
          </div>
        </div>
        <div className="row mx-1 d-flex justify-content-between">
          <div className="col-3 col-md-2 px-2">
            <Skeleton height={35} />
            <Skeleton height={35} />
          </div>
          <div className="col-3 col-md-2 px-2">
            <Skeleton height={35} />
            <Skeleton height={35} />
          </div>
        </div>

        {[0, 1, 2].map((a) => (
          <div key={a} className="row m-0 mb-4 mt-3">
            <div className="col-3 col-md-2 px-2">
              <Skeleton variant="rect" className="prRectSkeleton" />
            </div>
            <div className="col-9 col-md-10 px-2">
              <Skeleton
                height={30}
                style={{
                  transform: "translate(2px, 0)",
                  marginBottom: "10px",
                }}
              />
              <Skeleton height={25} />
              <Skeleton height={25} />
            </div>
          </div>
        ))}
      </>
    );

  // @Functions
  return (
      <Page title={`${vendorsConfig.APP_NAME} - OpenBill`}>
      hello
      {" "}
      {!formStatus ? (
        <div id="wrapper">
          <section id="topNav" className="fixed-top">
            <nav className="bckNavbar col-md-12 col-xl-5 d-flex justify-content-between align-items-center p-0 px-1 ">
              <div className="d-flex align-items-center">
                <Link to="/">
                  <IconButton
                    aria-label="back" 
                    className={
                      appState.langValue === "ar" ? "backBtnAr" : "backBtn2"
                    }
                  // orderbckBtn"
                  >
                    {appState.langValue === "ar" ? (
                      <ArrowForwardIosIcon
                        style={{ padding: "0px !important" }}
                        fontSize="inherit"
                      />
                    ) : (
                      <ArrowBackIosIcon fontSize="inherit" />
                    )}
                  </IconButton>
                </Link>

              </div>
                {/* <p className="text-center ">{get_lang(appState.storeInfo.businessName, appState.langValue)}</p> */}
                <h5 className="mt-2 d-flex">{t("open-order.Open-Order")}</h5>

              <div>
          

                {appState.langValue == "ar" ? (
                  <IconButton id="headerBtn" onClick={(e) => enLanguageHandle(e)}>
                    <span className={`lang-textScroll p-0`}>EN</span>
                  </IconButton>
                ) : (
                  <IconButton
                    id="headerBtn"
                    onClick={(e) => arLanguageHandle(e)}
                    className="arabicBtn"
                  >
                    <span className={`arabicText lang-textScroll p-0 mb-2`}>
                      عربي{" "}
                    </span>
                  </IconButton>
                )}
              </div>




            </nav>
          </section>
          <div id="openOrder" className="mt-5">
            {/* {appState.storeInfo.storeCategory && (
              <div className="d-flex mb-4 py-4 flex-column align-items-center justify-content-center w-100 progress_card">
                <Avatar
                  variant="square"
                  src={
                    appState.storeInfo.storeCategory.open_bill_icon
                      ? `${appState.storeInfo.storeCategory.open_bill_icon}`
                      : `${noImg}`
                  }
                ></Avatar>
                <h5 className="mt-3">
                  {t("open-order.Your-Order-is-In-Progress")}...
                </h5>
                <div className="w-100 px-3">
                  <LinearProgress
                    className="w-100 mt-3"
                    variant="determinate"
                    value={progress}
                  />
                </div>
              </div>
            )} */}

          

            <section id="order-pro" className="">
              {true ? (
                [
                  {
                      "id": 12269,
                      "product": {
                          "id": 2923,
                          "name": {
                              "en": "Americano",
                              "ar": ""
                          },
                          "image": null,
                          "hasAddons": false,
                          "parent": null,
                          "remaining_quantity": null
                      },
                      "category": {
                          "id": 1,
                          "name": {
                              "en": "Coffee",
                              "ar": "\u0627\u0644\u0642\u0647\u0648\u0629"
                          },
                          "image": "https:\/\/enabillapi.s3.amazonaws.com\/store\/products\/categories\/6bjVHQgPXk5Iw8ZneBDcAYXusM2d6ObaRZ1mBoho.jpg",
                          "invoice_order": 2
                      },
                      "quantity": 1,
                      "price": 10,
                      "device_id": "681042b8-583c-4954-bf9d-9d891ebd231e",
                      "customer_id": 321,
                      "total": 10,
                      "addons": [],
                      "campaign": null,
                      "note": null,
                      "loyalty_card_reward": null,
                      "meta": "618c5017-71b5-4b95-a3aa-0da4c026b294",
                      "status": "Pending",
                      "meal": 1,
                      "sum_addons": 0,
                      "discount": 0,
                      "discount_type": "fixed",
                      "amount": 10,
                      "addon_tax": 0,
                      "total_tax": 0,
                      "created_at": "2023-10-12T11:10:40.000000Z",
                      "updated_at": "2023-10-12T11:10:40.000000Z"
                  },
                  {
                      "id": 12270,
                      "product": {
                          "id": 2923,
                          "name": {
                              "en": "Americano",
                              "ar": ""
                          },
                          "image": null,
                          "hasAddons": false,
                          "parent": null,
                          "remaining_quantity": null
                      },
                      "category": {
                          "id": 1,
                          "name": {
                              "en": "Coffee",
                              "ar": "\u0627\u0644\u0642\u0647\u0648\u0629"
                          },
                          "image": "https:\/\/enabillapi.s3.amazonaws.com\/store\/products\/categories\/6bjVHQgPXk5Iw8ZneBDcAYXusM2d6ObaRZ1mBoho.jpg",
                          "invoice_order": 2
                      },
                      "quantity": 1,
                      "price": 10,
                      "device_id": "681042b8-583c-4954-bf9d-9d891ebd231e",
                      "customer_id": 321,
                      "total": 10,
                      "addons": [],
                      "campaign": null,
                      "note": null,
                      "loyalty_card_reward": null,
                      "meta": "3ddd59dd-4523-4c25-a63a-6979b05678a4",
                      "status": "Pending",
                      "meal": 2,
                      "sum_addons": 0,
                      "discount": 0,
                      "discount_type": "fixed",
                      "amount": 10,
                      "addon_tax": 0,
                      "total_tax": 0,
                      "created_at": "2023-10-12T11:30:13.000000Z",
                      "updated_at": "2023-10-12T11:30:13.000000Z"
                  }
              ].map((item, ind) => (
                  <div className="w-100" key={ind}>
                    {/* <OrderProduct item={item} /> */}
                    <OrderProductv2
                      index={ind}
                      item={item}
                    />
                    {ind === dineinOrders.length - 1 ? "" : <hr />}
                  </div>
                ))
              ) : (
                <div className="d-flex align-items-center justify-content-center flex-column">
                  <img className="img-pro" src={`/images/Frame.png`} alt="" />
                  <h1> {t("cart.No-items")}</h1>
                  <p> {t("cart.You-don�t-have-any-items-in-your-basket")}</p>
                </div>
              )}
            </section>

          </div>
        </div>
      ) : (
        // <Redirect push to={`/checkout`} />
        ""
      )}
    </Page>
  );
}

export default withTranslation()(OrderStatus);
